<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>员工费用</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button size="mini"
               v-if="authorities.includes('finance.yuangongfeiyong.new')"
               @click="toNewUserCostPage">新建员工费用</el-button>
    <el-button size="mini"
               v-if="authorities.includes('finance.yuangongfeiyong.copy')"
               @click="toCopyUserCostPage">复制员工费用</el-button>
    <el-button size="mini"
               v-if="authorities.includes('finance.yuangongfeiyong.edit')"
               @click="toEditUserSubsidyPage">编辑员工补助</el-button>
    <br>
    <el-date-picker
      v-model="costRequest.selectMonth"
      type="monthrange"
      range-separator="至"
      start-placeholder="开始月份"
      end-placeholder="结束月份"
      size="mini"
      @change="getMonth"
      value-format="yyyy-MM"
    >
    </el-date-picker>
    <el-select v-model="selectOrgId" v-if="orgLevel == 2" clearable value filterable placeholder="请选择门店"
               style="margin-left: 5px;width: 200px" size="mini" @change="getShop">
      <el-option
        v-for="org in shop"
        :key="org.id"
        :label="org.orgName"
        :value="org.id">
      </el-option>
    </el-select>
    <el-select v-model="selectUserId" clearable value filterable placeholder="请选择员工"
               style="margin-left: 5px;width: 200px" size="mini" @change="getUser">
      <el-option
        v-for="user in shopUserList"
        :key="user.id"
        :label="user.userName"
        :value="user.id">
      </el-option>
    </el-select>
    <el-select v-model="costRequest.costId" clearable value filterable placeholder="请选择补助类目"
               style="margin-left: 5px;width: 200px" size="mini" @change="getOrgCostMethod">
      <el-option
        v-for="orgCost in orgCostList"
        :key="orgCost.costId"
        :label="orgCost.costCnName"
        :value="orgCost.costId">
      </el-option>
    </el-select>
    <el-button size="mini" style="margin-left: 5px;" @click="loadUserCosts">查询</el-button>
    <el-table height="550px" :data="userCostList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
              :row-style="{height: '0'}" >
      <el-table-column
        align="center"
        fixed="fixed"
        label="操作" width="100"
      >
        <template slot-scope="scope">
          <div style="display: flex;justify-content: space-evenly">
            <el-link icon="el-icon-edit" size="mini"
                     type="primary"  @click="showUpdateCostDialog(scope.row)"
            ></el-link>
            <el-link type="primary" v-if="authorities.includes('finance.yuangongfeiyong.delete')" icon="el-icon-delete"
                     @click="deleteUserCost(scope.row)"></el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="costDate"
        label="时间">
      </el-table-column>
      <el-table-column
        align="center"
        prop="costCnName"
        label="费用类目">
      </el-table-column>
      <el-table-column
        align="center"
        prop="money"
        label="金额">
      </el-table-column>
      <el-table-column
        align="center"
        prop="userName"
        label="员工姓名">
      </el-table-column>
      <el-table-column
        align="center"
        prop="orgName"
        label="所在门店"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="comment"
        label="备注">
      </el-table-column>
      <el-table-column
        align="center"
        prop="createName"
        label="创建人">
      </el-table-column>
      <el-table-column
        align="center"
        prop="createTime"
        label="创建时间" width="200">
      </el-table-column>
      <el-table-column
        align="center"
        prop="modifyName"
        label="最后修改人">
      </el-table-column>
      <el-table-column
        align="center"
        prop="modifyTime"
        label="最后修改时间" width="200">
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="currentTotal">
    </el-pagination>

    <el-dialog
      title="更新员工费用"
      :visible.sync="updateCostDialogVisible"
      width="60%"
      @close="closeUpdateCostDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card class="box-card">
        <div style="display: flex;justify-content: space-evenly; width: 100%;align-items: center">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <span style="width: 60px">选择月份:</span>
            <el-date-picker
              v-model="updateUserCost.costDate"
              type="month"
              placeholder="选择月份"
              value-format="yyyy-MM"
              size="mini"
              style="width: 70%"
            >
            </el-date-picker>
          </div>
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <span style="width: 60px">费用类型:</span>
            <el-input v-model="updateUserCost.costCnName" disabled style="width: 60%" size="mini" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
          </div>
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <span style="width: 60px">金额:</span>
            <el-input v-model="updateUserCost.money" style="width: 60%" size="mini" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
          </div>
          <div style="display: flex;justify-content: flex-start;align-items: center" v-if="orgLevel == 2">
            <span style="width: 60px">所属门店:</span>
            <el-input v-model="updateUserCost.orgName" disabled style="width: 60%" size="mini" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
          </div>
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 10px">
        <span>备注说明：</span>
        <el-input v-model="updateUserCost.comment" style="width: 100%" size="mini" type="textarea"></el-input>
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeUpdateCostDialog">取 消</el-button>
        <el-button size="mini" @click="updateUserCostMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      orgId:'',
      userId:'',
      userName:'',
      orgLevel:'',
      authorities:'',
      userCostDialogVisible:false,
      userCostList:[],
      orgCostList:[],
      users:[],
      shop:[],
      selectUserList:[],
      selectAreaId:'',
      selectOrgId:'',
      selectOrgCostId:'',
      loadUsersOrgId:'',
      selectUserId:'',
      currentPage: 1,
      pageSize: 20,
      currentTotal: 0,
      userDialogVisible:false,
      updateCostDialogVisible:false,
      userCost:{
        costDate:'',
        money:'',
        orgId:'',
        userList:[],
        costId:'',
        creator:'',
        comment:'',
        orgLevel:'',
        createName:''
      },
      updateUserCost:'',
      selectUserButton:true,
      costRequest:{
        selectMonth:'',
        pageNum:'',
        pageSize:'',
        costType:'',
        orgId:'',
        loadUsersOrgId:'',
        costDate:'',
        costId:'',
        orgLevel:'',
        userId:'',
        queryText:'',
        orgName:'',
        startDateStr:'',
        endDateStr:''
      },
      modifyUserCostDialogVisible:false,
      shopUserList:[],
      createUserSubsidyDoubleClick:false,
    }
  },
  methods:{
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadUserCosts();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadUserCosts();
    },
    toNewUserCostPage(){
      this.$router.push("/new/employee/cost")
    },
    toCopyUserCostPage(){
      this.$router.push("/copy/employee/cost")
    },
    toEditUserSubsidyPage(){
      this.$router.push('/edit/employee/cost')
    },
    getOrgCostMethod(data){
      this.selectOrgCostId = data;
      this.userCost.costId = data;
    },
    async loadUsers(){
      this.costRequest.loadUsersOrgId = this.orgId;
      this.costRequest.costDate = this.userCost.costDate;
      this.costRequest.costId = this.userCost.costId;
      this.costRequest.orgLevel = this.orgLevel;
      const {data:res} = await this.$http.post(`/cost/users`, this.costRequest);
      this.users = res.data;
    },
    async loadOrgCost(){
      const {data:res} = await this.$http.get(`/cost/orgId/${this.orgId}/costType/${2}`);
      this.orgCostList = res.data;
    },
    async loadUserCostCount(){
      this.costRequest.costType = 2;
      this.costRequest.pageNum = this.currentPage;
      this.costRequest.pageSize = this.pageSize;
      this.costRequest.orgId = this.orgId;
      if(this.selectOrgId !== ''){
        this.costRequest.orgId = this.selectOrgId;
      }
      this.costRequest.orgLevel = this.orgLevel;
      const {data:res} = await this.$http.post(`/count/cost/userCosts`, this.costRequest);
      if (res.code === 200){
        this.currentTotal = res.totalPage;
      }
    },
    async loadUserCostsCount(){
      this.costRequest.costType = 2;
      this.costRequest.pageNum = this.currentPage;
      this.costRequest.pageSize = this.pageSize;
      if (this.costRequest.selectMonth !== ''){
        this.costRequest.startDateStr = this.costRequest.selectMonth[0];
        this.costRequest.endDateStr = this.costRequest.selectMonth[1];
      } else {
        this.costRequest.startDateStr = this.getNowMonth();
        this.costRequest.endDateStr = this.getNowMonth();
      }
      if (this.selectOrgId === ''){
        this.costRequest.orgId = this.orgId;
      } else {
        this.costRequest.orgId = this.selectOrgId;
        this.costRequest.orgLevel = 3;
      }
      this.costRequest.orgLevel = this.orgLevel;
      const {data:res} = await this.$http.post(`/count/cost/userCosts`, this.costRequest);
      if (res.code === 200){
        this.currentTotal = res.totalPage;
      }
    },
    async loadUserCosts(){
      this.costRequest.costType = 2;
      this.costRequest.pageNum = this.currentPage;
      this.costRequest.pageSize = this.pageSize;
      this.costRequest.orgId = this.orgId;
      if(this.selectOrgId !== ''){
        this.costRequest.orgId = this.selectOrgId;
      }
      if (this.costRequest.selectMonth !== ''){
        this.costRequest.startDateStr = this.costRequest.selectMonth[0];
        this.costRequest.endDateStr = this.costRequest.selectMonth[1];
      } else {
        this.costRequest.startDateStr = this.getNowMonth();
        this.costRequest.endDateStr = this.getNowMonth();
      }
      this.costRequest.orgLevel = this.orgLevel;
      const {data:res} = await this.$http.post(`/cost/userCosts`, this.costRequest);
      if (res.code === 200){
        this.userCostList = res.data;
      }

      // const {data:res2} = await this.$http.post(`/cost/userCosts/orgList`, this.costRequest);
      // if (res2.data !== null){
      //   this.shop = res2.data;
      // }
    },
    async deleteUserCost(row){
      const {data:res} = await this.$http.post(`/cost/delete/userCost`, row);
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      await this.loadUserCosts();
    },
    async getShop(data){
      this.selectOrgId = data;
      if (data !== ''){
        const {data:res} = await this.$http.get(`/org/users/${data}`);
        this.shopUserList = res.data;
      } else {
        this.costRequest.orgId = 0;
        await this.loadAllUser();
      }
    },
    async loadUser(data){
      const {data:res} = await this.$http.get(`/org/users/${data}`);
      this.shopUserList = res.data;
    },
    getUser(data){
      this.selectUserId = data;
      if (this.selectUserId === ''){
        this.costRequest.userId = 0;
      } else {
        this.costRequest.userId = data;
      }
    },
    async loadShopList(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      this.shop = res.data;
    },
    getMonth(data){
      if (data !== null){
        this.costRequest.selectMonth = data;
      } else {
        this.costRequest.selectMonth = '';
      }
      this.loadUserCostsCount();
      this.loadUserCosts();
    },
    getNowMonth() {
      const timeOne = new Date()
      const year = timeOne.getFullYear()
      let month = timeOne.getMonth() + 1
      month = month < 10 ? '0' + month : month
      return `${year}-${month}`
    },
    async copyLastMonthUserSubsidy(){
      this.costRequest.userId = this.userId;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/copy/cost/userCosts`, this.costRequest);
      if (res.code === 200){
        this.$message.success("操作成功！");
      }
      this.costRequest.userId = 0;
      await this.loadUserCostCount();
      await this.loadUserCosts();
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
    },
    showUpdateCostDialog(data){
      this.updateUserCost = data;
      this.updateCostDialogVisible = true;
    },
    closeUpdateCostDialog(){
      this.updateCostDialogVisible = false;
    },
    async updateUserCostMethod(){
      //检查是否该月已经存在数据
      // const {data:re} = await this.$http.post(`/check/cost/user`, this.updateUserCost);
      // if (re.data > 0){
      //   await this.loadUserCosts();
      //   return this.$message.warning("该月已经存在数据，不能修改到此月！")
      // }
      this.updateUserCost.modifyName = this.userName;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.put(`/cost/user`, this.updateUserCost);
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      await this.loadUserCosts();
      this.closeUpdateCostDialog();
    },
    async loadAllUser(data){
      const {data:res} = await this.$http.get(`/area/users/${data}`);
      this.shopUserList = res.data;
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.userName = window.sessionStorage.getItem("userName");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.loadOrgCost();
    this.loadUserCostsCount();
    this.loadUserCosts();
    if (this.orgLevel == 2){
      this.loadShopList();
      this.loadAllUser();
    }
    if (this.orgLevel == 3){
      this.loadUser(this.orgId);
    }
  }


}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
.box-card{
  margin: 10px 10px 10px 10px;
  height: 87%;
}
/deep/ .el-dialog{
  background: #fafaff !important;
}

/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}

/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}

/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  margin-bottom:0;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 10px 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/EmployeeCost.vue